import { render, staticRenderFns } from "./RegularAbstract.vue?vue&type=template&id=0aaad944&scoped=true"
import script from "./RegularAbstract.vue?vue&type=script&lang=js"
export * from "./RegularAbstract.vue?vue&type=script&lang=js"
import style0 from "./RegularAbstract.vue?vue&type=style&index=0&id=0aaad944&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aaad944",
  null
  
)

export default component.exports